const SectionFromHome = Class(
    /**
     * @lends {SectionFromHome#}
     */
    {
        bodyClass: 'small-nav full-container',
        menuItem: 'from-home',
        background: 7,

        __construct() {
            this.node = mkE({
                tag: 'div',
                id: 'from-home'
            });
        },

        draw() {
            mkE({
                tag: 'div',
                className: 'container from-home-welcome',
                els: [
                    {
                        tag: 'div',
                        className: 'from-home-block',
                        els: [
                            {
                                tag: 'div',
                                className: 'caption',
                                text: D.Lang.get('from-home.welcome.caption')
                            },
                            {
                                tag: 'div',
                                className: 'title',
                                text: D.Lang.get('from-home.welcome.title')
                            },
                            {
                                tag: 'div',
                                className: 'text',
                                text: D.Lang.get('from-home.welcome.description')
                            },
                            {
                                tag: 'div',
                                className: 'text',
                                text: D.Lang.get('from-home.welcome.description2')
                            },
                            new T.Download()
                        ]
                    }
                ]
            }).append(this.node);


            mkE({
                tag: 'div',
                className: 'container from-home-setup',
                els: [
                    {
                        tag: 'div',
                        className: 'from-home-block',
                        els: [
                            {
                                tag: 'div',
                                className: 'title',
                                text: D.Lang.get('from-home.setup.title')
                            }
                        ]
                    }
                ]
            }).append(this.node);
            this._drawSetup();

            this._drawGames();

            mkE({
                tag: 'div',
                className: 'container from-home-experience',
                els: [
                    {
                        tag: 'div',
                        className: 'from-home-block',
                        els: [
                            {
                                tag: 'div',
                                className: 'caption',
                                text: D.Lang.get('from-home.experience.caption')
                            },
                            {
                                tag: 'div',
                                className: 'title',
                                text: D.Lang.get('from-home.experience.title')
                            },
                            {
                                tag: 'div',
                                className: 'text',
                                text: D.Lang.get('from-home.experience.description')
                            }
                        ]
                    }
                ]
            }).append(this.node);
            this._drawHowTo();
            this._drawSocials();
            this.node.append(this.layout.ct());

            this.apiCall.call();
        },

        _drawSetup() {
            let setupSwitch = mkE({
                tag: 'div',
                id: 'setup-switch'
            });
            for (let i = 1; i <= 4; i++) {
                if (i > 1) {
                    mkE({
                        tag: 'div',
                        className: 'steps-separator'
                    }).append(setupSwitch);
                }
                mkE({
                    tag: 'a',
                    id: 'setup-switch-' + i,
                    className: i === 1 ? 'active' : '',
                    onclick: D.closure(this, this._goStep, i, true),
                    text: i
                }).append(setupSwitch);
            }
            mkE({
                tag: 'div',
                id: 'setup',
                className: 'container setup-wrapper',
                els: [
                    {
                        tag: 'div',
                        className: 'row',
                        els: [
                            {
                                tag: 'div',
                                className: 'col-12 col-md-4',
                                els: [
                                    {
                                        tag: 'div',
                                        id: 'setup-image-container',
                                        els: [
                                            this._lottieContainer = mkE({
                                                tag: 'div',
                                                id: 'setup-image'
                                            })
                                        ]
                                    }
                                ]
                            },
                            {
                                tag: 'div',
                                className: 'col-12 col-md-8',
                                els: [
                                    setupSwitch,
                                    {
                                        tag: 'div',
                                        id: 'setup-steps',
                                        els: [
                                            {
                                                tag: 'div',
                                                className: 'setup-step',
                                                els: [
                                                    this._stepsTitle = mkE({
                                                        tag: 'h3',
                                                        className: 'active',
                                                        text: D.Lang.get('from-home.setup.steps.' + 1 + '.caption')
                                                    }),
                                                    this._stepsText = mkE({
                                                        tag: 'p',
                                                        text: D.Lang.get('from-home.setup.steps.' + 1 + '.description')
                                                    })
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }).append(this.node);
        },

        _goStep(step, switchAnimation) {
            if (this.currentStep === step) {
                return;
            }
            removeClassName(document.getElementById('setup-switch-' + this.currentStep), 'active');
            this.currentStep = step;
            setNodeText(this._stepsTitle, D.Lang.get('from-home.setup.steps.' + this.currentStep + '.caption'));
            setNodeText(this._stepsText, D.Lang.get('from-home.setup.steps.' + this.currentStep + '.description'));
            addClassName(document.getElementById('setup-switch-' + this.currentStep), 'active');
            if (switchAnimation === true) {
                let timers = {
                    1: 0,
                    2: 120,
                    3: 240,
                    4: 360
                };
                this._animation.goToAndPlay(timers[step], true);
            }
        },

        onShow() {
            this.currentStep = 1;
            this.steps = 4;
            this._animation = lottie.loadAnimation({
                container: this._lottieContainer,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: '/assets/animations/from-home/ez-play.json?v=2'
            });
            this._animation.addEventListener("enterFrame", event => {
                if (event.currentTime < 120) {
                    this._goStep(1, false);
                } else if (event.currentTime < 240) {
                    this._goStep(2, false);
                } else if (event.currentTime < 360) {
                    this._goStep(3, false);
                } else {
                    this._goStep(4, false);
                }
            });

            if( this._eventsSlider ) {
                D.onLoad('Glide', this._eventsSlider.onShow);
            }
        },

        onLeave() {
            this._animation.destroy();
        },

        _drawHowTo() {
            let tasks = [
                'groupie',
                'matchmaker',
                'detective',
                'explorer',
                'expert'
            ];
            let defaultTask = 'explorer';
            this.currentHowTo = defaultTask;

            let links = mkE({
                tag: 'div',
                className: 'how-to-links'
            });
            let images = mkE({
                tag: 'div',
                className: 'how-to-image'
            });
            tasks.forEach(task => {
                mkE({
                    tag: 'a',
                    id: 'how-to-link-' + task,
                    className: task === defaultTask ? 'active' : '',
                    els: [
                        {
                            tag: 'span',
                            className: 'dot'
                        },
                        {
                            tag: 'span',
                            className: 'text',
                            text: D.Lang.get('from-home.how-to.' + task + '.caption')
                        }
                    ],
                    onclick: () => {
                        let n = document.getElementById('how-to-play-new');
                        removeClassName(n, 'how-to-' + this.currentHowTo);
                        removeClassName(document.getElementById('how-to-link-' + this.currentHowTo), 'active');
                        removeClassName(document.getElementById('how-to-image-' + this.currentHowTo), 'active');
                        this.currentHowTo = task;
                        addClassName(n, 'how-to-' + this.currentHowTo);
                        addClassName(document.getElementById('how-to-link-' + this.currentHowTo), 'active');
                        addClassName(document.getElementById('how-to-image-' + this.currentHowTo), 'active');
                        setNodeText(document.querySelector('.how-to-task .pink'), D.Lang.get('from-home.how-to.' + task + '.caption2'));
                        setNodeText(document.querySelector('.how-to-task p'), D.Lang.get('from-home.how-to.' + task + '.description'));
                    }
                }).append(links);

                mkE({
                    tag: 'img',
                    id: 'how-to-image-' + task,
                    className: task === defaultTask ? 'active' : '',
                    src: '/assets/images/from-home/how-to/slides/' + task + '.png',
                    attr: {
                        srcset: '/assets/images/from-home/how-to/slides/' + task + '.png 1x, ' + '/assets/images/from-home/how-to/slides/' + task + '@2x.png 2x, ' + '/assets/images/from-home/how-to/slides/' + task + '@3x.png 3x'
                    }
                }).append(images);
            });

            mkE({
                tag: 'div',
                id: 'how-to-play-new',
                className: 'how-to-' + defaultTask,
                els: [
                    {
                        tag: 'div',
                        className: 'how-to-wrapper container',
                        els: [
                            {
                                tag: 'div',
                                className: 'question-top'
                            },
                            {
                                tag: 'div',
                                className: 'question-bottom'
                            },
                            {
                                tag: 'div',
                                className: 'row',
                                els: [
                                    {
                                        tag: 'div',
                                        className: 'col-12 col-lg-2 order-1 order-md-2 order-lg-0',
                                        els: [
                                            links
                                        ]
                                    },
                                    {
                                        tag: 'div',
                                        className: 'col-12 col-md-6 col-lg-5 order-0 order-lg-1',
                                        els: [
                                            {
                                                tag: 'div',
                                                className: 'how-to-image-container',
                                                els: [
                                                    images
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tag: 'div',
                                        className: 'col-12 col-md-6 col-lg-5 order-2 order-md-1 order-lg-2',
                                        els: [
                                            {
                                                tag: 'div',
                                                className: 'how-to-content',
                                                els: [
                                                    {
                                                        tag: 'div',
                                                        className: 'caption',
                                                        text: D.Lang.get('from-home.how-to.content.caption')
                                                    },
                                                    {
                                                        tag: 'div',
                                                        className: 'how-to-tasks',
                                                        els: [
                                                            {
                                                                tag: 'div',
                                                                className: 'how-to-task',
                                                                els: [
                                                                    {
                                                                        tag: 'h3',
                                                                        els: [
                                                                            D.Lang.get('from-home.how-to.content.prefix') + ' ',
                                                                            {
                                                                                tag: 'span',
                                                                                className: 'pink',
                                                                                text: D.Lang.get('from-home.how-to.' + defaultTask + '.caption2')
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        tag: 'p',
                                                                        text: D.Lang.get('from-home.how-to.' + defaultTask + '.description')
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }).append(this.node);
        },

        _drawSocials() {
            mkE({
                tag: 'div',
                className: 'container home-socials',
                els: [
                    T.SocialIcons('home')
                ]
            }).append(this.node);
        },

        _drawGames() {
            mkE({
                tag: 'div',
                className: 'container from-home-games',
                els: [
                    {
                        tag: 'div',
                        className: 'from-home-block',
                        els: [
                            {
                                tag: 'div',
                                className: 'title',
                                text: D.Lang.get('from-home.games.title')
                            },
                            this._eventsSlider = new SectionFromHome.EventsSlider(this.apiCall)
                        ]
                    }
                ]
            }).append(this.node);
        }
    },
    Section
);

/**
 * @class
 * @extends mkE.Base
 */
SectionFromHome.EventsSlider = Class(
  /**
   * @lends {SectionFromHome.Events#}
   */
  {
      /** @param {DR.ApiCall} apiCall */
      __construct( apiCall ) {
          this.node = mkE({
              tag: 'div',
              className: 'events-slider',
              style: {
                  display: 'none'
              }
          });

          this._mGetEvents = new DR.events.GetEventsList();
          this._mGetEvents.type = DR.events.GetEventsList.TYPE_ANYTIME;
          this._mGetEvents.select = [
              new DR.events.select.Event().id().image().title(),
              new DR.roadgames.select.Image().large()
          ];
          this._mGetEvents.onLoad = this._mGetEventsRe;
          if( apiCall ) {
              apiCall.addMethod(this._mGetEvents);
          } else {
              this._mGetEvents.call();
          }
      },

      _mGetEventsRe() {
          let els = [];
          for( let i = 0; i < this._mGetEvents.re.events.length; i++ ) {
              const eventListItem = this._mGetEvents.re.events[i];
              els.push({
                  tag: 'div',
                  className: 'event glide__slide',
                  els: [
                      {
                          tag: 'a',
                          href: D.url('/download'),
                          className: 'event-wrapper',
                          style: {
                              backgroundImage: 'url(' + eventListItem.event.image.large + ')'
                          },
                          els: [
                              {
                                  tag: 'div',
                                  className: 'event-title',
                                  els: [
                                      {
                                          tag: 'span',
                                          className: 'event-title-valign'
                                      },
                                      {
                                          tag: 'span',
                                          className: 'event-title-text',
                                          text: eventListItem.event.title
                                      }
                                  ]
                              }
                          ]
                      }
                  ]
              });
          }

          this._glideNode = mkE({
              tag: 'div',
              className: 'glide',
              els: [
                  this._leftArrow = mkE({
                      tag: 'div',
                      className: 'arrow arrow-left',
                      id: 'quotes-left',
                      onclick: this._eventsBack
                  }),
                  this._rightArrow = mkE({
                      tag: 'div',
                      className: 'arrow arrow-right',
                      id: 'quotes-right',
                      onclick: this._eventForward
                  }),
                  {
                      tag: 'div',
                      className: 'glide__track',
                      attr: {
                          'data-glide-el': 'track'
                      },
                      els: [
                          this._glideInnerNode = mkE({
                              tag: 'div',
                              className: 'glide__slides quotes',
                              els: els
                          })
                      ]
                  }
              ]
          }).append(this.node);

          this.pseudoSlide = this._mGetEvents.re.events.length <= this._getSliderPerView();
          if( this._mGetEvents.re.events.length <= this._getSliderPerView() ) {
              this._leftArrow.style.display = 'none';
              this._rightArrow.style.display = 'none';
          }
      },

      _eventsBack() {
          this._slider.go('<');
      },

      _eventForward() {
          this._slider.go('>');
      },

      _getSliderGap() {
          if( window.innerWidth < 1134 ) {
              return 12;
          } else {
              return 64;
          }
      },

      _getSliderPeek() {
          if( window.innerWidth < 1134 ) {
              const slideWith = 248;
              const preSlide = window.innerWidth <= 320 ? 0 : 16;
              const afterSlide = this.node.offsetWidth - this._getSliderPerView() * slideWith - preSlide;
              return {before: preSlide, after: afterSlide};
          } else {
              return 0;
          }
      },

      _getSliderPerView() {
          if( window.innerWidth < 1134 ) {
              const w = this._getSliderGap() + 248;
              return Math.floor(this.node.offsetWidth / w);
          } else {
              return 3;
          }
      },

      _onSliderResize() {
          this._slider.update({
              gap: this._getSliderGap(),
              peek: this._getSliderPeek(),
              perView: this._getSliderPerView()
          });
      },

      onShow() {
          this.node.style.display = '';
          this._slider = new Glide(this._glideNode, {
              type: 'slider',
              startAt: 0,
              perView: this._getSliderPerView(),
              focusAt: 0,
              gap: this._getSliderGap(),
              peek: this._getSliderPeek(),
              rewind: true,
              bound: true
          });
          this._slider.on('resize', this._onSliderResize);
          this._slider.mount();
      }
  },
  mkE.Base
);
